var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-layout"},[_c('main-header'),_c('div',{staticClass:"main-content"},[_c('router-view')],1),_c('main-footer'),_c('loader'),_c('notifications',{attrs:{"group":"general","position":"bottom right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }